import { TaskGroupBy, TaskLinkType } from './task.enum';

export interface TaskViewOptions {
    groupBy: TaskGroupBy;
    sortBy: TaskGroupBy;
    sortOrder: 'asc' | 'desc';
    filterValue: any;
    entityName: TaskLinkType;
    showEmptyGroups?: boolean;

    /** #WBS-2956 Not sure what is for */
    options: {
        showEmptyGroups: boolean
    }
}

export const defaultViewOptions: TaskViewOptions = {
    groupBy: TaskGroupBy.None,
    sortBy: TaskGroupBy.None,
    sortOrder: 'asc',
    filterValue: null,
    entityName: null,
    showEmptyGroups: false,

    /** #WBS-2956 Not sure what this for */
    options: {
        showEmptyGroups: false
    }
}